import AppConfig from "../../../../config/appconfig.json";

const checkAgreement = function(kbeSid) {
    if (kbeSid == null) return;

    let isCheckAgreementFailed = false;
    const request = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        Sid: kbeSid
      })
    };
    fetch(`${AppConfig.BACK_END_URL}/APIClient/CheckAgreement`, request)
      .then(response => {
        // console.log(response);
        if (response.ok === false) {
          isCheckAgreementFailed = true;
        }
        return response.json();
      })
      .then(json => {
        // console.log(json);
        if (isCheckAgreementFailed) {
          // const respObj = JSON.parse(json);
          // console.log(respObj.Message);
          window.location.reload();
        } else {
          localStorage.setItem("kbeAgreement", "true");
          window.location.reload();
        }
      })
      .catch(() => {
        console.log(
          "Something went wrong when checking agreement. Please try again."
        );
      });
};

export { checkAgreement };


// WEBPACK FOOTER //
// ./src/pages/account/log_in/components/CheckAgreement.js